import { IClientSDK } from '@sxm-web/client-sdk-core';
import { fetchWithAuthorization } from '../../../helpers/fetch-with-authorization';
import { VehicleStateResponse } from '../types';
import { getAccessToken } from '../../../helpers/get-access-token';

export type DeviceStatusByVinFn = (payload: {
    request: {
        vin: string;
    };
    accessToken: string;
}) => Promise<VehicleStateResponse>;

export function initDeviceStatusByVinFn({
    baseUrl,
    clientSdk,
}: {
    baseUrl: string;
    clientSdk: IClientSDK;
}): DeviceStatusByVinFn {
    const href = 'client-orchestration/v1/state/vin/{vin}';
    return async ({ request: { vin }, accessToken }) => {
        const url = `${baseUrl}/${href.replace('{vin}', vin)}`;
        let response = await fetchWithAuthorization({
            url,
            method: 'GET',
            accessToken,
        });
        if (response.status === 401) {
            await clientSdk.user.refreshToken();
            const accessTokenNew = getAccessToken();
            response = await fetchWithAuthorization({
                url,
                method: 'GET',
                accessToken: accessTokenNew,
            });
        }
        if (!response.ok) return Promise.reject(await response.json());
        return response.json();
    };
}
